import type { ProductExtensionState } from '@krp/client-runtime'

/** Окно карточки источника: вид окна и его параметры. */
export interface SourceProductCard {
  kind: string
  params: Record<string, string>
}

/**
 * Описание вида источника для общей карточки товара (ADR-21, RP-FB71). Общий код вида не знает: описание объявляет пакет вида
 * (как читать расширение карточки и показать его сводкой), а composition добавляет к нему окно карточки источника — так же,
 * как формы подключения (`createConnectionFormRegistry`). Данные расширения разбирает только описание в пакете вида.
 */
export interface SourceProductDescriptor {
  /** Вид ресурса (`resource.kind`), для которого описание. */
  kind: string
  /** Читает расширение карточки у службы вида и отдаёт готовый вид. Хук: вызывается строкой блока «Источники». */
  useExtension: (resourceId: string, remoteKey: string) => ProductExtensionState
  /** Окно карточки источника для кнопки «Открыть карточку источника»; нет — у вида такого окна нет. */
  openCard?: ((resourceId: string, remoteKey: string) => SourceProductCard) | undefined
}

export interface SourceProductRegistry {
  /** Описание вида; `undefined` — вид без описания (общая карточка скажет об этом словами). */
  descriptorOf: (kind: string) => SourceProductDescriptor | undefined
  kinds: readonly string[]
}

/** Реестр описаний. Повтор вида — ошибка сборки: два описания одного вида читали бы одно расширение двумя способами. */
export function createSourceProductRegistry(descriptors: readonly SourceProductDescriptor[]): SourceProductRegistry {
  const byKind = new Map<string, SourceProductDescriptor>()
  for (const descriptor of descriptors) {
    if (descriptor.kind.trim() === '') throw new Error('У описания источника товара не задан вид.')
    if (byKind.has(descriptor.kind)) throw new Error(`Описание источника товара вида «${descriptor.kind}» уже зарегистрировано.`)
    byKind.set(descriptor.kind, descriptor)
  }
  return { descriptorOf: (kind) => byKind.get(kind), kinds: [...byKind.keys()] }
}

export const EMPTY_SOURCE_PRODUCTS: SourceProductRegistry = createSourceProductRegistry([])
